export const clearShopProductSelection = (
  section: string,
  selectedShopProductId: string | null,
  setSelectedShopProductId: (value: string | null) => void,
) => {
  if (section === 'shop-products') return
  if (selectedShopProductId !== null) {
    setSelectedShopProductId(null)
  }
}
